import { observer } from "mobx-react-lite";

import { useSportPartnersTableState } from "./table.state";
import { SportPartnersTableView } from "./table.view";

export const SportPartnersTable = observer(() => {
  const state = useSportPartnersTableState();
  return <SportPartnersTableView state={state} />;
});
